import React from 'react'
import PapperIcon from './icons/papper'
import SectionFetcher from './SectionFetcher'

type TermModalProps = {
  handleAcceptTerm?: () => void
}

const TermsModal: React.FC<TermModalProps> = ({ handleAcceptTerm }) => {
  return (
    <div className="overlay">
      <div className="term-container-body">
        <div className="term-modal-header">
          <PapperIcon />
          <h2>Terms and conditions</h2>
        </div>
        <SectionFetcher url="https://www.vocads.com/gcs-20241015" />
        <div className="term-modal-footer">
          <button onClick={handleAcceptTerm} className="decline-button">
            Decline
          </button>
          <button
            className="accept-button"
            disabled={handleAcceptTerm === undefined}
            onClick={handleAcceptTerm}
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  )
}

export default TermsModal
